import React from 'react';
import StatisticsTable from './statistics-table';
import {acceptanceLikelihoodClassification} from 'shared/college-profile/utils';
import AcceptanceLikelihoodExplanation from './acceptance-likelihood/acceptance-likelihood-explanation';
import Icon from 'shared/components/icon';

interface Props {
  college: {
    satCriticalReadingRange?: number[];
    satMathematicsRange?: number[];
  };
  userInfo: {
    satScore?: {
      scoreReadingAndWriting: number;
      scoreMathematics: number;
    };
  };
  showAdmissability?: boolean;
}

interface Row {
  name: string;
  values: React.ReactNode[];
}

const SATTable = ({
  college: {satCriticalReadingRange, satMathematicsRange},
  userInfo: {satScore},
  showAdmissability,
}: Props) => {
  const addDefaultScores = (values: React.ReactNode[]) => {
    values.push(<a href="/portfolio#scores">Enter Score to See Match</a>);
    values.push(<Icon iconType="lock-alt" className="admissability-locked-icon" />);
  };

  const getRows = (): Row[] => {
    const rows: Row[] = [];

    if (satCriticalReadingRange) {
      const values: React.ReactNode[] = [
        `${satCriticalReadingRange[0]}-${satCriticalReadingRange[1]}`,
      ];

      if (showAdmissability) {
        if (satScore) {
          values.push(satScore.scoreReadingAndWriting);
          values.push(
            acceptanceLikelihoodClassification(
              satScore.scoreReadingAndWriting,
              satCriticalReadingRange[0],
              satCriticalReadingRange[1]
            )
          );
        } else {
          addDefaultScores(values);
        }
      }

      rows.push({
        name: 'SAT English',
        values,
      });
    }

    if (satMathematicsRange) {
      const values: React.ReactNode[] = [`${satMathematicsRange[0]}-${satMathematicsRange[1]}`];

      if (showAdmissability) {
        if (satScore) {
          values.push(satScore.scoreMathematics);
          values.push(
            acceptanceLikelihoodClassification(
              satScore.scoreMathematics,
              satMathematicsRange[0],
              satMathematicsRange[1]
            )
          );
        } else {
          addDefaultScores(values);
        }
      }

      rows.push({
        name: 'SAT Math',
        values,
      });
    }

    return rows;
  };

  const rows = getRows();

  const cols: React.ReactNode[] = ['Subject', 'Avg. Range'];

  if (showAdmissability) {
    cols.push('Your Score');
    cols.push(
      <span>
        Match
        <AcceptanceLikelihoodExplanation />
      </span>
    );
  }

  const className = showAdmissability ? (satScore ? 'wide-row-headers' : 'with-score-cta') : '';

  return (
    <StatisticsTable className={className} aria-label="SAT Breakdown" header={cols} rows={rows} />
  );
};

export default SATTable;
